import React, { useState, useEffect } from "react";
import {
    Card,
    CardHeader,
    CardContent,
    CardMedia,
    Box, Typography,
} from "@mui/material";
import uploadplan from "../assets/landing_page/Images/Upload Plan.png";
import uploadplan1 from "../assets/landing_page/Images/Upload Plan1.png";
import adduser from "../assets/landing_page/Images/Add User.png";
import exploreplan from "../assets/landing_page/Images/Explore Templates.png";
import http from "../utils/http-common";
import { useNavigate, useLocation } from "react-router-dom";
import { setTemplateForCreate } from "../Slices/planslice";
import { useDispatch } from "react-redux";
function Dashboard(props) {

    const [planList, setPlanList] = useState([]);
    const [emptyUser, setEmptyUser] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

      const handleClick = (path, title) => {
        if (title === 'Create Plan') {
          dispatch(setTemplateForCreate({
            isTemplate: false,
            table: false,
            isTemplateToPlan: false,
            isBlankPlan: true,
            isView : false,
            isEdit: false,
            isDelete: false,
            isShare: false,
          }));
        }
        navigate(path);
      };
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const handleOpen = (event) => {
        setOpen(true);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setOpen(false);
        setAnchorEl(null);
    };


    useEffect(() => {
        getPlan();
    }, []);
    const [planData, setPlanData] = useState([]);
    const getPlan = async () => {
        try {
            const response = await http.get(
                "/master_service/get_all/plan_master/records"
            );

            if (response.status === 200) {
                if (response.data.length === 0) {
                    setEmptyUser(true);
                }
                setPlanData(response.data);
            }
        } catch (error) {
            console.error("Error fetching data", error);
        }
    };

    return (
        <div style={{ height: "100vh" }}>
            <>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "2px 0",
                        marginTop: 13
                    }}>
                    <Typography
                        sx={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "28px",
                            fontWeight: 600,
                            lineHeight: "28px",
                            textAlign: "center",
                            marginBottom: "15px"
                        }}>
                        Welcome to PlanShare 🎉
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "14px",
                            //fontWeight: 400,
                            textAlign: "center",
                            marginBottom: "5px"
                        }}>
                        Optimize your projects today by uploading a plan or exploring templates.
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "14px",
                            lineHeight: "10px",
                            textAlign: "center",
                            marginBottom: "20px"
                        }}>
                        Run a scheduled analysis, keep your team aligned, and share effortlessly.
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "18px",
                            fontWeight: 700,
                            lineHeight: "26px",
                            textAlign: "center"
                        }}>
                        Take the next step
                    </Typography>

                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1.8,
                        //paddingRight: "13px",
                        paddingLeft: "11px",
                    }}
                >
                    {[
                        { image: uploadplan, title: "Create Plan", path: "/home/createplan" },
                        { image: uploadplan1, title: "Upload Plan", path: "/home/createplan" },
                        { image: adduser, title: "Add User", path: "/home/adduser" },
                        { image: exploreplan, title: "Explore Templates", path: "/home/templates" },
                    ].map((card, index) => (
                        <Card
                            key={index}
                            variant="outlined"
                            onClick={() => handleClick(card.path, card.title)}
                            sx={{
                                width: 190,
                                height: 180, // Fixed height for all cards
                                margin: "10px", // Spacing between cards
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between", // Ensures content is spaced evenly
                                cursor: "pointer",
                            }}
                        >
                            <CardContent sx={{ px: 1, py: 2.5 }}>
                                <Box
                                    sx={{
                                        position: "relative",
                                        width: "100%",
                                        height: 90, // Fixed height for the image container
                                        "&:hover": {
                                            color: "#0000001A",
                                        },
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        image={card.image}
                                        alt={card.title}
                                        sx={{
                                            height: "100%", // Ensures it takes full height of the container
                                            width: "100%", // Ensures it takes full width of the container
                                            objectFit: "contain", // Ensures the entire image fits inside without being cropped
                                            display: "block", // Avoids extra space around the image
                                            margin: "auto", // Centers the image
                                            backgroundColor: "#FFF",
                                            transition: "background-color 0.3s ease",
                                        }}
                                    />

                                </Box>
                                <Box
                                    sx={{
                                        borderBottom: "1px solid #ccc",
                                        backgroundColor: "#E5EEFB66",
                                        marginTop: "8px", // Space between image and text
                                    }}
                                />
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "3px", // Space between title and subtitle
                                        marginTop: "8px", // Extra space above the text
                                        backgroundColor: "transparent",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontFamily: "Inter, sans-serif",
                                            fontSize: "12px",
                                            fontWeight: 600,
                                            lineHeight: "16px",
                                            textAlign: "center",
                                            color: "black",
                                            whiteSpace: "normal", // Allows text to wrap
                                            wordWrap: "break-word", // Ensures words break properly
                                        }}
                                    >
                                        {card.title}
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            </>
        </div>
    );
}

export default Dashboard;
